import { useRef, useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation, Pagination, Autoplay } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

const HeroCarousel = ({ slides = [], autoPlay = true, interval = 5000 }) => {
  const [isHovered, setIsHovered] = useState(false)
  const swiperRef = useRef(null)
    
  // Default slides if none provided
  const defaultSlides = [
    {
      id: 1,
      image: '/images/hero/hero-1.jpg',
      title: 'Joyas Exclusivas',
      cta: 'Ver Colección',
      ctaLink: '/categoria/all'
    },
    {
      id: 2,
      image: '/images/hero/hero-2.jpg',
      title: 'Anillos de Compromiso',
      cta: 'Explorar Anillos',
      ctaLink: '/categoria/anillos'
    }
  ]
    
  const carouselSlides = slides.length > 0 ? slides : defaultSlides
    
  const handleImageError = (e) => {
    e.target.src = '/images/no-image.png'
  }
    
  return (
    <div 
      className="relative h-[300px] sm:h-[400px] md:h-[500px] lg:h-[600px] w-full overflow-hidden"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Swiper
        ref={swiperRef}
        modules={[Navigation, Pagination, Autoplay]}
        spaceBetween={0}
        slidesPerView={1}
        navigation={{
          nextEl: '.hero-button-next',
          prevEl: '.hero-button-prev'
        }}
        pagination={{
          clickable: true,
          el: '.hero-pagination'
        }}
        autoplay={autoPlay && !isHovered ? {
          delay: interval,
          disableOnInteraction: false
        } : false}
        loop={carouselSlides.length > 1}
        className="h-full w-full"
      >
        {carouselSlides.map((slide) => (
          <SwiperSlide key={slide.id} className="relative">
            <div className="relative h-full w-full">
              {/* Background Image */}
              <img
                src={slide.image}
                alt={slide.title}
                className="absolute inset-0 h-full w-full object-cover"
                onError={handleImageError}
              />
                            
              {/* Overlay */}
              <div className="absolute inset-0 bg-primary-black bg-opacity-40" />
                            
              {/* Content */}
              <div className="relative z-10 h-full flex items-end">
                <div className="text-left px-6 sm:px-8 lg:px-12 pb-8 sm:pb-12 lg:pb-16 max-w-2xl">
                  <h1 className="text-3xl sm:text-5xl font-title font-medium text-white mb-4">
                    {slide.title}
                  </h1>
                  <a
                    href={slide.ctaLink}
                    className="inline-block bg-white text-primary-text text-lg sm:text-2xl font-body p-2 sm:p-3 font-semibold hover:bg-primary-light transition-all duration-300 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-primary-black"
                  >
                    {slide.cta}
                  </a>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
            
      {/* Custom Navigation */}
      {carouselSlides.length > 1 && (
        <>
          <button className="hero-button-prev absolute left-4 top-1/2 transform -translate-y-1/2 z-10 bg-white bg-opacity-20 hover:bg-opacity-40 p-2 rounded-full transition-all duration-300">
            <svg className="w-6 h-6 text-black" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clipRule="evenodd" />
            </svg>
          </button>
          <button className="hero-button-next absolute right-4 top-1/2 transform -translate-y-1/2 z-10 bg-white bg-opacity-20 hover:bg-opacity-40 p-2 rounded-full transition-all duration-300">
            <svg className="w-6 h-6 text-black" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
            </svg>
          </button>
        </>
      )}
            
      {/* Custom Pagination */}
      {carouselSlides.length > 1 && (
        <div className="hero-pagination absolute bottom-4 left-1/2 transform -translate-x-1/2 z-10 flex space-x-2"></div>
      )}
    </div>
  )
}

export default HeroCarousel